import React from 'react';
import { render } from '@testing-library/react';
import { ButtonGroup } from './ButtonGroup';
import { Button } from '../Button';

describe('ButtonGroup', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<ButtonGroup data-auto-sel="automation-selector">
				<Button primary>Action</Button>
				<Button>Small Action</Button>
				<Button>Secondary Action</Button>
				<Button iconName="add" />
			</ButtonGroup>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
